<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col
                lg="8"
                xl="9"
                md="6"
                cols="12"
                class="d-flex flex-column mb-4">
                <h2 slot="header" class="mb-0">รายงานการจัดส่ง</h2>
                <div class="text-body-1">แสดงการจัดส่งทั้งหมดที่มีอยู่</div>
              </b-col>
              <b-col lg="4" xl="3" md="6" cols="12" class="text-right">
                <div
                  class="d-flex flex-row justify-content-end align-items-center">
                  <span class="text-body-1 pr-1">ราคารวม</span>
                  <h1 class="font-weight-bold text-primary">
                    {{ job_net.toLocaleString("en-US") }}
                  </h1>
                  <span class="text-body-1 pl-1">บาท</span>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="12" class="mb-2">
                <b-form-datepicker
                  placeholder="วันที่เริ่ม"
                  v-model="dates.start"
                  class="mb-2"
                  locale="th"></b-form-datepicker>
              </b-col>
              <b-col lg="3" md="12" class="mb-2">
                <b-form-datepicker
                  placeholder="วันที่สิ้นสุด"
                  v-model="dates.end"
                  class="mb-2"
                  locale="th"></b-form-datepicker>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-form-input v-model="searchTerm" placeholder="ค้นหาชื่องาน">
                </b-form-input>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-button
                  @click="getJob()"
                  variant="primary"
                  block
                  class="d-flex align-items-center justify-content-center">
                  <b-icon icon="search" class="mr-2"></b-icon> ค้นหา
                </b-button>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-button
                  variant="primary"
                  block
                  class="d-flex align-items-center justify-content-center"
                  @click="handleDownloadPdf()">
                  <b-icon icon="download" class="mr-2"></b-icon> Export
                </b-button>
              </b-col>
            </b-row>
            <!-- table -->
            <b-row class="mt-4">
              <b-col>
                <b-table
                  responsive
                  :fields="fields"
                  :items="items"
                  :busy="isLoading"
                  class="custom-table">
                  <template #cell(index)="data">
                    {{
                      calculateIndex(
                        data,
                        pagination.currentPage,
                        pagination.perPage
                      )
                    }}
                  </template>
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>
                  <template #cell(net)="data">
                    {{ +data.item.net | number }}
                  </template>
                  <template #cell(status)="data">
                    <template v-if="data.item.status === 'success'">
                      <b-badge variant="success" class="w-100"
                        >เสร็จสิ้น</b-badge
                      >
                    </template>
                    <template v-else-if="data.item.status === 'wait'">
                      <b-badge variant="dark" class="w-100"
                        >รอดำเนินการ</b-badge
                      >
                    </template>
                    <template v-else>
                      <b-badge variant="yellow" class="w-100"
                        >กำลังดำเนินการ</b-badge
                      >
                    </template>
                  </template>
                  <template #cell(manage)="data">
                    <b-button
                      variant="outline-border"
                      size="sm"
                      @click="
                        $router.push({
                          name: 'jobDeatil',
                          params: { id: data.item.id },
                        })
                      ">
                      <b-icon icon="pencil-square"></b-icon>
                    </b-button>
                    <!-- <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="openModalConfirm(data.item.id)">
                      <b-icon icon="trash-fill"></b-icon>
                    </b-button> -->
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex justify-content-end">
                <b-pagination
                  v-model="pagination.currentPage"
                  :disabled="isLoading"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.perPage"
                  aria-controls="my-table"
                  class="mt-3"
                  @change="(page) => getJob(page)"></b-pagination>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </b-container>
    <ModalConfirm
      ref="confirmDelete"
      :confirm="confirm"
      @confirmModal="onDeleteJob" />
  </div>
</template>
<script>
import jobServices from "@/api/job.service.js";
import calculateIndex from "@/util/calculateIndex.js";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import downloadLink from "@/util/downloadLink.js";
import { getCurrentDateInThaiFormat } from "@/util/datetime-manager.js";

export default {
  components: { ModalConfirm },
  props: {},
  data() {
    return {
      downloadLink,
      isLoadPage: false,
      calculateIndex,
      isLoading: false,
      job_net: 0,
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 0, // จำนวนข้อมูลทั้งหมด
      },
      confirm: {
        show: false,
        icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
        emphasize: "ต้องการลบรายการ",
        text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
        isLoad: false,
        id: null,
      },
      dates: {
        start: getCurrentDateInThaiFormat(),
        end: getCurrentDateInThaiFormat(),
      },
      searchTerm: null,
      jobTypeSelected: null,
      jobStatusSelected: null,
      listJobType: [
        { value: null, text: "ประเภทงานทั้งหมด" },
        { value: "flex", text: "ตามระยะทาง" },
        { value: "fix", text: "ราคาเดียว" },
      ],
      listStatusJob: [
        { value: null, text: "สถานะงานทั้งหมด" },
        { value: "wait", text: "รอส่ง" },
        { value: "pending", text: "กำลังจัดส่ง" },
        { value: "success", text: "ส่งสำเร็จ" },
      ],
      items: [],
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "started_datetime",
          label: "วันที่กำหนดเริ่มงาน",
          formatter: (value) => {
            if (!value) return "";

            // แปลง value เป็นวันที่ JavaScript (สมมติว่า value อยู่ในรูปแบบ ISO 8601)
            const date = new Date(value);

            // จัดรูปแบบวันที่เป็น YYYY-MM-DD
            const formattedDate = date.toISOString().split("T")[0];

            // จัดรูปแบบเวลาเป็น HH:mm
            const formattedTime = date
              .toTimeString()
              .split(" ")[0]
              .substring(0, 5);

            // รวมวันที่และเวลา
            return `${formattedDate} ${formattedTime}`;
          },
        },
        {
          key: "created_date",
          label: "วันที่สร้างงาน",
          formatter: (value) => {
            if (!value) return "";

            // แปลง value เป็นวันที่ JavaScript (สมมติว่า value อยู่ในรูปแบบ ISO 8601)
            const date = new Date(value);

            // จัดรูปแบบวันที่เป็น YYYY-MM-DD
            const formattedDate = date.toISOString().split("T")[0];

            // จัดรูปแบบเวลาเป็น HH:mm
            const formattedTime = date
              .toTimeString()
              .split(" ")[0]
              .substring(0, 5);

            // รวมวันที่และเวลา
            return `${formattedDate} ${formattedTime}`;
          },
        },
        {
          key: "jobRateType.name",
          label: "ประเภทงาน",
        },
        {
          key: "status",
          label: "สถานะงาน",
        },
        {
          key: "driver.firstname",
          label: "ชื่อคนขับ",
        },
        {
          key: "vehicle.plate",
          label: "ทะเบียนรถ",
        },
        {
          key: "job_name",
          label: "ชื่องาน",
        },
        {
          key: "customer_shop_name",
          label: "ชื่อบริษัท/ร้านค้า",
        },
        {
          key: "net",
          label: "ราคาสุทธิ",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
    };
  },
  created() {
    this.getJob();
  },
  methods: {
    async getJob(page = 1) {
      this.isLoading = true;
      this.isLoadPage = true;
      const param = {
        page,
        started_datetime: this.dates.start,
        ended_datetime: this.dates.end,
        status: "success",
        filters: this.searchTerm,
      };
      try {
        const response = await jobServices.getJob(param);
        this.items = response.data.data.items;
        this.pagination.totalRows = response.data.data.meta.totalItems;
        this.pagination.perPage = response.data.data.meta.itemsPerPage;
        this.pagination.currentPage = response.data.data.meta.currentPage;
        this.isLoading = false;
        this.job_net = response.data.data.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadPage = false;
      }
    },
    async onDeleteJob() {
      try {
        this.isLoadPage = true;

        await jobServices.removeJob(this.confirm.id);
        this.getJob();
        this.$refs.confirmDelete.closeModalConfirm();
      } catch (error) {
      } finally {
        this.isLoadPage = false;
      }
    },
    openModalConfirm(jobId) {
      this.confirm.show = true;
      this.confirm.id = jobId;
      this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
      this.confirm.emphasize = "ต้องการลบรายการ";
      this.confirm.text =
        "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
    },
    async handleDownloadPdf() {
      this.isLoadPage = true;
      try {
        const token = localStorage.getItem("token");

        fetch(`${process.env.VUE_APP_BASE_URL}/jobs/jobs-export`, {
          headers: new Headers({
            Authorization: `Bearer ${token}`,
          }),
        })
          .then((x) => x.blob())
          .then((blob) => {
            this.downloadLink(blob, "report.xlsx");
          });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadPage = false;
      }
    },
  },
  mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
